import React from 'react';
import { MapPin, Info } from 'lucide-react';

const LocationGuide = () => {
  return (
    <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
      <div className="flex items-start">
        <Info className="h-5 w-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
        <div>
          <h3 className="font-semibold text-blue-800 mb-1">Informazioni sulle Coordinate Geografiche</h3>
          <p className="text-blue-600 text-sm mb-2">
            Le coordinate geografiche vengono utilizzate per:
          </p>
          <ul className="text-blue-600 text-sm list-disc ml-5 space-y-1">
            <li>Posizionare precisamente l'immobile sulle mappe dei portali immobiliari</li>
            <li>Calcolare la distanza dell'immobile dai punti di interesse</li>
            <li>Migliorare la visibilità dell'immobile nelle ricerche geografiche</li>
          </ul>
          <div className="mt-3 p-3 bg-white rounded-lg flex items-start">
            <MapPin className="h-5 w-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm text-gray-700 font-medium">
                Puoi utilizzare il pulsante "Calcola coordinate dall'indirizzo" per ottenere automaticamente le coordinate
                geografiche in base all'indirizzo inserito. Il calcolo utilizza l'indirizzo, la zona e la provincia per una maggiore precisione.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Formato coordinate: decimale con punto (es. latitudine: 43.756111, longitudine: 11.178889)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationGuide;